import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import PartNumbers from '../PartNumbers/PartNumbers';
import ProductName from './ProductName';
import ProductPrice from './ProductPrice';
import ProductStock from './ProductStock';
import ProductBanner from './ProductBanner';

const ProductInfo = (props) => {
  const { className, children } = props;

  return <div className={cn('o-media__body', className)}>{children}</div>
};

export default ProductInfo;

ProductInfo.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  stock: PropTypes.string,
  banner: PropTypes.string,
};

ProductInfo.defaultProps = {
  className: '',
};

ProductInfo.PartNumbers = PartNumbers;
ProductInfo.Name = ProductName;
ProductInfo.Price = ProductPrice;
ProductInfo.Stock = ProductStock;
ProductInfo.Banner = ProductBanner;
